import React, { useState } from 'react'
import '../../Organisms/single-page-common/single-page-content-header.scss'
import { ButtonWithIcon } from '../../Atoms/Buttons/ButtonWithIcon'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { ArchivePopup } from '../../Organisms/Popups/General/ArchivePopup'
import { createScript } from '../../../store/script/api'
import { toast } from 'react-toastify'
import { handleError } from '../../../utils/handleErrors'
import { updateEntity } from '../../../store/common/api'
import { createSegment } from '../../../store/segment/api'
import { createValueSetter } from '../../../store/valueSetter/api'

export const Header = ({
    entity,
    entityType = 'valueSetter',
    entityURL = 'value-setters',
}) => {
    const history = useHistory()
    const params = useParams()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const type = searchParams.get('type')
    const [archivePopup, setArchivePopup] = useState(false)
    const cancel = () => {
        history.push(`/${entityURL}`)
        setArchivePopup(false)
    }

    const save = () => {
        console.log('save createValueSetter')
        createValueSetter({ ...entity, modelId: params.modelId })
            .then(() => {
                history.push(`/${entityURL}`)
                toast.success('Successfully Created')
            })
            .catch(handleError)
    }
    const edit = () => {
        updateEntity(params.id, entityType, {
            name: entity.name,
            body: entity.body,
            modelId: entity.modelId,
        })
            .then(() => {
                toast.success('Successfully Updated')
            })
            .catch(handleError)
    }
    console.log('handleSaveOrEdit', entity.id)
    const handleSaveOrEdit = params.id ? edit : save

    return (
        <>
            <ArchivePopup
                isOpen={archivePopup}
                togglePanel={setArchivePopup}
                onDelete={cancel}
                text="Are you sure you want to cancel"
            ></ArchivePopup>

            <div className="single-page-content-header">
                <div className="title">
                    <span>{entity.name}</span>
                </div>
                {!type ? (
                    <div className="actions">
                        <ButtonWithIcon
                            onClick={() => setArchivePopup(true)}
                            icon="/assets/images/Delete.png"
                            red={true}
                            value="Cancel"
                        />
                        <ButtonWithIcon
                            onClick={handleSaveOrEdit}
                            value="Save"
                            green={true}
                        />
                    </div>
                ) : (
                    <ButtonWithIcon
                        onClick={() => history.goBack()}
                        red={true}
                        value="Back"
                    />
                )}
            </div>
        </>
    )
}
